export const parseFieldValueForUpdate = (field, value) => {
    if (!value?.length) return null;

    switch (field) {
        case 'costo':
            return Number.isFinite(Number(value)) ? Number(value) : null;
        case 'diasEntrega':
            return Number.isFinite(Number.parseInt(value, 10)) ? Number.parseInt(value, 10) : null;
        default:
            return value;
    }
}